import { mk } from "../../../../date-fns/locale/mk.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    mk
  }
};